import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tooltip } from 'seagull';
import { LinkIcon } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { formatDuration, timeTextsPath } from '~/models/time';
import { Accounting } from '~/types/api.model';
import { formatShortMonthUSDate } from '~/utils';
import styles from './TimeActivityTooltip.module.scss';
const TimeActivityTooltip = (param)=>{
    let { timeActivity, grouped = false } = param;
    const { t: timeTexts } = useLocaleKeys(timeTextsPath);
    const { t: tooltipTexts } = useLocaleKeys('components.timeActivityTooltip');
    const accountingName = getAccountingDetails(Accounting.QBO).fullName;
    return /*#__PURE__*/ _jsx(Tooltip, {
        testId: "time-activity-".concat(timeActivity.id, "-tooltip"),
        title: /*#__PURE__*/ _jsx("div", {
            style: {
                minWidth: 'fit-content'
            },
            "data-testid": "time-activity-tooltip-text",
            children: grouped ? tooltipTexts.groupedDescription({
                accountingName
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    tooltipTexts.connectedIntro({
                        accountingName
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    tooltipTexts.customerLabel(),
                    " ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.customer.name
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    tooltipTexts.dateLabel(),
                    " ",
                    /*#__PURE__*/ _jsx("b", {
                        children: formatShortMonthUSDate(new Date(timeActivity.date))
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    tooltipTexts.mappedServiceNameLabel(),
                    " ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.item.name
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    tooltipTexts.durationLabel(),
                    ' ',
                    /*#__PURE__*/ _jsx("b", {
                        children: formatDuration({
                            hours: timeActivity.hours,
                            minutes: timeActivity.minutes,
                            texts: timeTexts
                        })
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    tooltipTexts.noteLabel(),
                    " ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.note
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.icon,
            "data-testid": "time-activity-".concat(timeActivity.id, "-icon"),
            children: /*#__PURE__*/ _jsx(LinkIcon, {
                size: 18
            })
        })
    });
};
export default TimeActivityTooltip;
